import React from "react";
import { Button } from "@design-system/Button/Button";
import { ButtonWithLoader } from "@design-system/Button/ButtonWithLoader";
import { CommandIsland } from "@design-system/CommandIsland/CommandIsland";
import styles from "./NativeInvoiceDrawer.module.scss";

interface NativeInvoicePdfOnlyPreviewProps {
    invoicePreview: React.ReactNode;
}

export const NativeInvoicePdfOnlyPreview: React.FC<
    NativeInvoicePdfOnlyPreviewProps
> = ({ invoicePreview }) => (
    <div className={styles.previewPane}>{invoicePreview}</div>
);

interface NativeInvoicePdfOnlyCommandBarProps {
    onClose: () => void;
    onDownload: () => void;
    isDownloading: boolean;
    onResend?: () => void;
}

export const NativeInvoicePdfOnlyCommandBar: React.FC<
    NativeInvoicePdfOnlyCommandBarProps
> = ({ onClose, onDownload, isDownloading, onResend }) => (
    <CommandIsland className={styles.commandBar}>
        <div className={styles.commandBarGroup}>
            <Button variant="primary" size="md" onClick={onClose}>
                Close
            </Button>
            <ButtonWithLoader
                variant="primary"
                size="md"
                onClick={onDownload}
                loading={isDownloading}
                disabled={isDownloading}
            >
                Download PDF
            </ButtonWithLoader>
        </div>
        {onResend && (
            <div className={styles.commandBarGroup}>
                <Button variant="primary" onClick={onResend}>
                    Send again
                </Button>
            </div>
        )}
    </CommandIsland>
);
